/// <reference path="./Container.ts" />
namespace HA.Core.HTML {
    export class FlexContainer extends Container {

        /**
         *
         * @param element
         */
        public insertOnTop(element: any) {
            super.insertOnTop(element);
        }

        /**
         *
         * @param element
         */
        public appendChild(element: any) {
            super.appendChild(element);
        }

        public centered() {
            this.addClass("fcenter");
        }

        public spaceAround() {
            this.addClass("fsaround");
        }

        /**
         *
         * @param element
         */
        public appendChildRight(element: any) {
            const i = element;
            i.addClass("fir");
            super.appendChild(i);
        }
        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("fc");
        }
    }
}
